import { DecimalResult, callDecimal } from "../utils";
import { addCourseParams } from "./course";

export interface CompareCartItem {
  catalogId: number;
  isbn: string;
  sectionId: string;
  itemId: string;
}

export interface CompareCart {
  id: number;
  bookItems: CompareCartItem[];
  totalPrice: string;
}

interface CompareSettingsResponse {
  compareSettings: CompareSettings;
}

export interface CompareSettings {
  contactEmail: string | null;
  preferredPartnerText: string;
  shortStoreName: string;
  storeUrl: string | null;

  // These are still being returned by the API but not sure if we need them

  // These are still being returned by the API but we should not need them

  // activeEpos: boolean;
  // allowInFrame: boolean;
  // allowedConditions: string;
  // baseUrl: boolean;
  // blockZeroInventory: boolean;
  // checkoutWarning: boolean;
  // comments: {new: string; used: string; ebook: string; rental: string;}
  // compareButtonText: string;
  // defaultMessage: string;
  // eratexSubstitutionsAlwaysOk: boolean;
  // eratexSubstitutionsNeverOk: boolean;
  // headerLinksToStore: boolean;
  // minimumInventory: string
  // noBooksLink: boolean;
  // noteZeroInventory: boolean;
  // optOuts: {
  //   connectUrl: string;
  //   contactEmailAddress: string;
  //   displayPortalLinkForm: boolean;
  //   info: string;
  //   studentIdName: string;
  //   studentIdExample: string;
  // }
  // outOfStockText: string;
  // programMessage: string;
  // programName: string;
  // retailers: string[];
  // reversePriceOrder: boolean;
  // storeName: string;
  // storeBranded: string[];
  // storeBrandedInStoreBlock: boolean;
  // uwash: boolean;
  // z3950: boolean;
}

// this has NO standard in Compete but these are the ones we're checking for
export type ItemVariant =
  | "used"
  | "new"
  | "rental"
  | "new_rental"
  | "used_rental"
  | "e-book"
  | "ebook"
  | "access_code";

export interface Offer {
  tempBookItemId: number;
  retailerName: string;
  fcondition: string; // fcondition is the same as condition on CheckoutItem
  variant: ItemVariant;
  fprice: string;
  comments: string;
  description: string;
  itemId: string;
  isbn: string;

  // These are still being returned by the API but not sure if we need them

  // canCheckout: boolean
  // currency: string
  // condition: string
  // highestPrice: string
  // id: string
  // location: string
  // lowestPrice: string
  // price: string
  // rentalDays: string
  // retailer: string
  // shipping: string
  // source: string
  // specialComment: string
  // total: string
  // oos: boolean,
  // quantity: number

  // These are still being returned by the API but we should not need them
}

export interface GroupedOffers {
  epos: Offer[];
  preferredRetailers: Offer[];
  retailers: Offer[];
  copyrightYear: string;
  edition: string;
  publisher: string;
}

export interface CheckoutItem {
  author: string;
  condition: string; // condition is the same as fcondition on Offer
  variant: ItemVariant;
  currency: string;
  formattedPrice: string;
  highestPrice: string;
  isbn: string;
  itemId: string;
  lowestPrice: string;
  price: string;
  primaryKeyId: number;
  shipping: string;
  status: string;
  title: string;
  url: string;
  checkoutUrl: string;
  catalogId: string;
  courseId: string;
  // These are still being returned by the API but not sure if we need them

  // These are still being returned by the API but we should not need them
}

export interface Checkout {
  hasSharedUrl: boolean;
  retailerBaseName: string;
  retailerName: string;
  items: CheckoutItem[];
  urls: string[];
  checkoutUrl: string;
  totalPrice: string;
  // These are still being returned by the API but not sure if we need them

  // These are still being returned by the API but we should not need them
  // form_data: // this will be used after MVP
}

export interface GroupedCheckout {
  epos: Checkout[];
  preferredRetailers: Checkout[];
  retailers: Checkout[];
  totalPrice: string;
}

export async function getCart(): Promise<DecimalResult<CompareCart>> {
  return callDecimal<CompareCart>(
    `/api/v1/my_courses/cart${addCourseParams()}`
  );
}

export async function getCompareSettings(): Promise<
  DecimalResult<CompareSettingsResponse>
> {
  return callDecimal<CompareSettingsResponse>(
    `/api/v1/my_courses/compare/settings${addCourseParams()}`
  );
}

export async function getOffers({
  isbn,
  courseId,
}: {
  isbn: string;
  courseId: string | number;
}): Promise<DecimalResult<GroupedOffers>> {
  return callDecimal<GroupedOffers>(
    `/api/v1/my_courses/offers/${isbn}${addCourseParams()}&course_id=${courseId}`
  );
}

export async function addToCart({
  tempId,
}: {
  tempId: string;
}): Promise<DecimalResult<CompareCart>> {
  return callDecimal<CompareCart>(
    `/api/v1/my_courses/cart/items/${tempId}${addCourseParams()}`,
    { method: "PUT" }
  );
}

export async function removeFromCart({
  id,
}: {
  id: string;
}): Promise<DecimalResult<CompareCart>> {
  return callDecimal<CompareCart>(
    `/api/v1/my_courses/cart/items/${id}${addCourseParams()}`,
    {
      method: "DELETE",
    }
  );
}

export async function getCheckout(): Promise<DecimalResult<GroupedCheckout>> {
  return callDecimal<GroupedCheckout>(
    `/api/v1/my_courses/cart/checkout${addCourseParams()}`
  );
}
